import { useState } from 'react';
import { testimonials } from '@/mocks/siteData';

export default function TestimonialSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const t = testimonials[activeIndex];

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <p className="font-heading text-2xl md:text-3xl text-foreground-400 italic text-center">
          ( Trusted by Shoppers )
        </p>

        <div className="mt-12 min-h-[260px]">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-foreground-900 rounded-full">
            <i className="ri-star-fill text-[#F5A623] text-sm"></i>
            <span className="text-background-50 text-sm font-semibold">{t.rating}</span>
          </div>

          <blockquote className="mt-6 font-heading text-lg md:text-xl italic text-foreground-700 leading-relaxed">
            &ldquo;{t.text}&rdquo;
          </blockquote>

          <div className="mt-6 flex items-center gap-4">
            <div className="w-14 h-14 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
              <p className="text-xs text-foreground-400">{t.location}</p>
            </div>
          </div>
        </div>

        <div className="mt-8 flex items-center justify-between">
          <div className="flex items-center gap-2">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setActiveIndex(i)}
                className={`h-2 rounded-full transition-all duration-300 ${
                  i === activeIndex
                    ? 'w-8 bg-primary-500'
                    : 'w-2 bg-foreground-200 hover:bg-foreground-300'
                }`}
                aria-label={`Go to testimonial ${i + 1}`}
              />
            ))}
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={() => setActiveIndex((prev) => (prev <= 0 ? testimonials.length - 1 : prev - 1))}
              className="w-10 h-10 rounded-lg border border-foreground-200 flex items-center justify-center text-foreground-400 hover:border-foreground-400 hover:text-foreground-700 transition-colors cursor-pointer"
              aria-label="Previous testimonial"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              onClick={() => setActiveIndex((prev) => (prev >= testimonials.length - 1 ? 0 : prev + 1))}
              className="w-10 h-10 rounded-lg bg-foreground-900 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
              aria-label="Next testimonial"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}